import {
  BuyingGuide64,
  FindaDealer64,
  CarValuationTool64,
  SellMyCar64,
  VehicleHistoryCheck64,
  Blog64,
  ElectricCars64,
  CarsFromDealerships64,
} from '../../../components/Toolkit/Base64/Sections';
interface Map {
  [name: string]: JSX.Element;
}

const GoFurtherIcons: Map = {
  'find-a-dealer': <FindaDealer64 />,
  'sell-my-car': <CarsFromDealerships64 />,
  'instant-offer': <SellMyCar64 />,
  'value-my-car': <CarValuationTool64 />,
  'buying-guide': <BuyingGuide64 />,
  'greenlight-history-check': <VehicleHistoryCheck64 />,
  'electric-cars': <ElectricCars64 />,
  blog: <Blog64 />,
};

export default GoFurtherIcons;
